import * as z from 'zod';
import { extractionStatusSchema, ExtractionStatus, extractionErrorTypeSchema } from '../../../enums.mjs';
import { fileId } from '../../opaque.mjs';
import { ContractExtractionOutput } from './contract-extraction-output.mjs';

var ContractExtractionResultPayload;
(function (ContractExtractionResultPayload) {
    ContractExtractionResultPayload.schema = z.object({
        fileId: fileId,
        status: extractionStatusSchema.extract([ExtractionStatus.Completed, ExtractionStatus.Partial]),
        processingSessionId: z.string().nullable(),
        output: ContractExtractionOutput,
        generatedPdf: z.string().nullable(),
    });
})(ContractExtractionResultPayload || (ContractExtractionResultPayload = {}));
var ContractExtractionFailurePayload;
(function (ContractExtractionFailurePayload) {
    ContractExtractionFailurePayload.schema = z.object({
        fileId: fileId,
        status: z.literal(ExtractionStatus.Failed),
        errorType: extractionErrorTypeSchema,
        errorMessage: z.string(),
    });
})(ContractExtractionFailurePayload || (ContractExtractionFailurePayload = {}));
var ContractExtractionWebhookPayload;
(function (ContractExtractionWebhookPayload) {
    ContractExtractionWebhookPayload.schema = z.discriminatedUnion("status", [
        ContractExtractionResultPayload.schema,
        ContractExtractionFailurePayload.schema,
    ]);
})(ContractExtractionWebhookPayload || (ContractExtractionWebhookPayload = {}));

export { ContractExtractionFailurePayload, ContractExtractionResultPayload, ContractExtractionWebhookPayload };
